import { createFeature, createReducer, on } from '@ngrx/store';

import {
    ApiVersion,
    defaultApiVersion,
    done,
    error,
    getInitialProgressState,
    ProgressState,
    running,
} from 'app/shared/models';

import {
    preloadApiConfig,
    preloadApiConfigSuccess,
    refreshApiVersionSuccess,
    registerApiConfig,
    registerApiConfigFailure,
    registerApiConfigSuccess,
    resetApiConfig,
} from './api-config.actions';

export const apiConfigFeatureKey = 'apiConfig';

export interface ApiConfigState {
    identifier: string;
    apiVersion: ApiVersion;
    preloadProgress: ProgressState;
    registerProgress: ProgressState;
}

export const initialState: ApiConfigState = {
    identifier: '',
    apiVersion: defaultApiVersion,
    preloadProgress: getInitialProgressState(),
    registerProgress: getInitialProgressState(),
};

export const reducer = createReducer(
    initialState,
    on(preloadApiConfig, (state) => {
        return state.preloadProgress.done || state.preloadProgress.running
            ? state
            : {
                  ...state,
                  preloadProgress: running(),
              };
    }),
    on(preloadApiConfigSuccess, (state, { identifier, apiVersion }) => ({
        ...state,
        identifier,
        apiVersion: apiVersion || defaultApiVersion,
        preloadProgress: done(),
    })),
    on(registerApiConfig, (state) => ({
        ...state,
        registerProgress: running(),
    })),
    on(registerApiConfigSuccess, (state, { identifier, apiVersion }) => ({
        ...state,
        identifier,
        apiVersion,
        registerProgress: done(),
    })),
    on(registerApiConfigFailure, (state, action) => ({
        ...state,
        registerProgress: error(action.error),
    })),
    on(refreshApiVersionSuccess, (state, { apiVersion }) => ({
        ...state,
        apiVersion,
    })),
    on(resetApiConfig, (state) => ({
        ...state,
        identifier: '',
        apiVersion: defaultApiVersion,
        registerProgress: getInitialProgressState(),
    })),
);

export const apiConfigFeature = createFeature({
    name: apiConfigFeatureKey,
    reducer,
});
